import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col } from "styled-bootstrap-grid";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu
} from "styled-dropdown-component";
import { CaretDown } from "styled-icons/boxicons-regular/CaretDown";
import ClickOutside from "react-simple-click-outside";
import Footer from "../../Shared/Footer";
import { saveProfileInformation } from "../../../Actions/Auth/saveUserInfo";
import { errorMessage } from "../../../Actions";
import { APP_CODE } from "../../../Constants";
import { withTranslation, Trans } from "react-i18next";

class Profile extends Component {
  constructor(props) {
    super();
    this.state = {
      hiddenBranch: true,
      hiddenLanguage: true,
      branchId: null,
      languageId: null
    };
  }
  submitData = () => {
    let data = {
      appCd: APP_CODE,
      ssoId: this.props.ssoId,
      branchId: this.state.branchId,
      languageId: this.state.languageId
    };
    if (this.state.branchId == null || this.state.languageId == null) {
      this.props.dispatch(
        errorMessage(["Please select any Branch Id and Language Id."])
      );
    } else {
      this.props.dispatch(saveProfileInformation(data));
    }
  };
  _close = target => {
    this.setState({
      [target]: true
    });
  };
  handleOpenCloseDropdown(dropdownHidden) {
    this.setState({
      [dropdownHidden]: !this.state[dropdownHidden]
    });
  }
  branchData = branch => {
    this.setState({
      hiddenBranch: true,
      branchId: branch.branchId
    });
  };
  languageData = languageId => {
    this.setState({
      hiddenLanguage: true,
      languageId: languageId.languageId
    });
  };
  backBtn = () => {
    if (this.props.userDefault.defaultProfile.emplRole ===
      "Workshop Manager" ||
      this.props.userDefault.defaultProfile.emplRole === "Workshop Admin") {
      this.props.history.push("/timetracking/" + this.props.ssoId + "/manager/home");
    }
    else {
      this.props.history.goBack();
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.branchId && !prevState.languageId) {
      return {
        branchId: nextProps.userDefault.defaultProfile.branchId,
        languageId: Number(nextProps.userDefault.defaultProfile.defaultLanguage)
      };
    } else return null
  }

  render() {
    const { hiddenBranch, hiddenLanguage, branchId, languageId } = this.state;
    let selectedBranch = this.props.branches.filter(branch => branch.branchId === branchId);
    let selectedLang = this.props.languages.filter(lang => lang.languageId === languageId);
    return (
      <Wrapper>
        {this.props.userDefault.defaultProfile.emplRole === "Workshop Manager" ||
          this.props.userDefault.defaultProfile.emplRole === "Workshop Admin" ? (
            <BreadcrumbsItem
              glyph
              to={
                "/timetracking/" + this.props.ssoId + "/manager/profile"
              }
            >
              <Trans>profile</Trans>
            </BreadcrumbsItem>
          ) : (
            <BreadcrumbsItem
              glyph
              to={
                "/timetracking/" + this.props.ssoId + "/technician/profile/profile"
              }
            >
              <Trans>profile</Trans>
            </BreadcrumbsItem>
          )}
        <RowBranch>
          <Col sm="2" />
          <Col sm="4">
            <DropDown>
              <ClickOutside close={this._close} target="hiddenBranch">
                <Div onClick={() => this.handleOpenCloseDropdown("hiddenBranch")}>
                  <InnerDiv>
                    {selectedBranch && selectedBranch[0] ? (
                      selectedBranch[0].branchId + " " + selectedBranch[0].branchName
                    ) : (
                        "Select Branch"
                      )}
                    <Caretdown />
                  </InnerDiv>
                </Div>
                <DropDownMenu hidden={hiddenBranch}>
                  {this.props.branches.map(data => (
                    <DropDownItem
                      onClick={() => this.branchData(data)}
                      key={data.branchId}
                    >
                      {data.branchId} {data.branchName}
                    </DropDownItem>
                  ))}
                </DropDownMenu>
              </ClickOutside>
            </DropDown>
          </Col>

          <Col sm="4">
            <DropDown>
              <ClickOutside close={this._close} target="hiddenLanguage">
                <Div
                  onClick={() => this.handleOpenCloseDropdown("hiddenLanguage")}
                >
                  <InnerDiv>
                    {selectedLang && selectedLang[0] ? (
                      selectedLang[0].languageName
                    ) : (
                        "Select Language"
                      )}
                    <Caretdown />
                  </InnerDiv>
                </Div>
                <DropDownMenu hidden={hiddenLanguage}>
                  {this.props.languages.map(data => (
                    <DropDownItem
                      onClick={() => this.languageData(data)}
                      key={data.languageId}
                    >
                      {data.languageName}
                    </DropDownItem>
                  ))}
                </DropDownMenu>
              </ClickOutside>
            </DropDown>
          </Col>
          <Col sm="2" />
        </RowBranch>
        <Footer>
          {" "}
          <BackButton onClick={this.backBtn}><Trans>back</Trans></BackButton>
          <ButtonSubmit
            Color={this.state.submitLogoutDisable}
            disabled={this.state.submitLogoutDisable}
            onClick={this.submitData}
          >
            <Trans>submit</Trans>
          </ButtonSubmit>
        </Footer>
      </Wrapper>
    );
  }
}
const ButtonSubmit = styled.button`
  background: ${props => (props.Color ? "#e1e5eb" : "#c4151c")};
  border-radius: 30px;
  padding: 0;
  border: ${props => (props.Color ? "1px solid #96989a;" : "none")};
  height: 34px;
  width: 129px;
  color: ${props => (props.Color ? "#939292;" : "#ffffff")};
  font-weight: 50;
  position: relative;
  left: 40px;
  font-size: 12px;
`;
const BackButton = styled.button`
  border: 2px solid #e0e0e0;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  background: #ffffff;
  color: #434f5b;
  font-size: 12px;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  font-size:20px;
`;
const Div = styled.div`
  position: relative;
  cursor: pointer;
  color: #6c757de8;
  border-bottom: 1px solid #6c757de8;
  text-align: -webkit-left;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 6px;
`;
const InnerDiv = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
const DropDown = styled(Dropdown)`
  position: relative;
  max-width:300px;
  min-width:220px;
  margin:0 auto;
`;
const DropDownMenu = styled(DropdownMenu)`
  width: 100%;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 200px;
  max-height: 200px;
  overflow-y: scroll;
  border-color: #adb5bd26;
  box-shadow: 2px 6px 21px -2px rgba(0, 0, 0, 0.75);
  font-family: sans-serif;
  border-radius: 4px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #343a40;
  }
`;
const DropDownItem = styled(DropdownItem)`
  font-family: sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Caretdown = styled(CaretDown)`
  width: 18px;
  color: rgba(0, 0, 0, 0.54);
  position: absolute;
  right: 5px;
  top: 5px;
`;
const RowBranch = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  margin-top:150px;
`;
const mapStateToProps = ({ auth }) => {
  return {
    branches: auth.user.Branches,
    languages: auth.user.Languages,
    ssoId: auth.appData.empId,
    userDefault: auth.user
  };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(Profile)));
